import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import BottomSheet from './BottomSheet';
import { Button } from '../MUIs';
import { BottomSheetActions } from '../../Reducer/BottomSheetReducer';
import { TbmActions } from '../../Reducer/TbmReducer';
import { useSelector } from 'react-redux';
import { useAppNavigate } from '../../Hooks/back/useAppNavigate';

export default function BackClickBottomSheetTbmEnd({
  open,
  TbmEnd,
  SaveLogic1,
}) {
  const { navigate } = useAppNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const guest = useSelector((state) => state.tbm.guest);

  const isPpeOrTbmYn =
    userInfo?.tbmYn === 'Y' || location.pathname === '/M_PPE';

  return (
    <BottomSheet
      open={open}
      isHeaderChildren={true}
      headerText={''}
      headerChildren={
        <Typography
          sx={{ fontSize: '18px', fontWeight: 'bold', display: 'flex' }}
        >
          {isPpeOrTbmYn
            ? '보호구 자가 체크와 보이스 체크를 진행하지 않으시겠습니까?'
            : '서명을 진행하지 않으시겠습니까?'}
        </Typography>
      }
    >
      <Box sx={{ px: 1 }}>
        <Typography style={{ color: '#918A8A', paddingBottom: '0.5rem' }}>
          {isPpeOrTbmYn
            ? '홈 화면의 작업 시작 버튼을 눌러 다시 진행할 수 있습니다.'
            : '서명을 건너뛰시면 오늘 참여하신 TBM 교육 이력이 저장되지 않습니다.'}
        </Typography>
      </Box>
      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          gap: 8,
        }}
      >
        <Button
          name="취소"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: 'transparent',
            border: `1px solid #776D6D`,
            color: '#776D6D',
            boxShadow: 'none',
          }}
          onClick={() => dispatch(BottomSheetActions.CloseBottomSheet())}
        />
        <Button
          name="확인"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={async () => {
            if (SaveLogic1) await SaveLogic1();
            if (TbmEnd) await TbmEnd?.();
            dispatch(BottomSheetActions.CloseBottomSheet());
            // 게스트(일반 카메라 QR 웹 참석)는 홈(로그인 필요) 대신 나가기 화면
            if (guest?.status === 'active') {
              dispatch(TbmActions.setGuestStatus('left'));
              return;
            }
            navigate('/Home', { replace: true });
          }}
        />
      </Box>
    </BottomSheet>
  );
}
